const API_HEADERS = {
  contentType: {
    applicationJsonPath: 'application/json-patch+json',
    textPlain: 'text/plain'
  }
};

export default API_HEADERS;
